import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const API_URL = `${API_BASE_URL}/admin`;

/**
 * Ottiene l'header di autorizzazione con il token admin
 */
const getAuthHeader = () => {
  const token = localStorage.getItem('adminToken');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

/**
 * Ottiene il profilo admin
 */
export const getProfile = async () => {
  try {
    const response = await axios.get(`${API_URL}/profile`, getAuthHeader());
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Errore nel recupero del profilo');
  }
};

/**
 * Aggiorna nome e cognome admin
 */
export const updateName = async (firstName, lastName) => {
  try {
    const response = await axios.put(
      `${API_URL}/profile/name`,
      { firstName, lastName },
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Errore nell\'aggiornamento del nome');
  }
};

/**
 * Aggiorna username admin
 */
export const updateUsername = async (newUsername, password) => {
  try {
    const response = await axios.put(
      `${API_URL}/profile/username`,
      { newUsername, password },
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Errore nell\'aggiornamento dello username');
  }
};

/**
 * Aggiorna password admin
 */
export const updatePassword = async (currentPassword, newPassword, confirmPassword) => {
  try {
    const response = await axios.put(
      `${API_URL}/profile/password`,
      { currentPassword, newPassword, confirmPassword },
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Errore nell\'aggiornamento della password');
  }
};

/**
 * Ottiene i log delle attività admin
 */
export const getActivityLogs = async (limit = 50, offset = 0) => {
  try {
    const response = await axios.get(
      `${API_URL}/activity-logs?limit=${limit}&offset=${offset}`,
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Errore nel recupero dei log');
  }
};

/**
 * Scarica i dati admin (GDPR)
 */
export const downloadData = async () => {
  try {
    const response = await axios.get(`${API_URL}/download-data`, getAuthHeader());
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Errore nel download dei dati');
  }
};
